import React from 'react';
import { graphql } from 'gatsby';
import WithSection from '../../components/WithSection/WithSection';
import { Head2, Body1 } from '../../components/Typography/Typography';
import Box from '../../components/Box/Box';
import CtaSlots from '../../slots/CtaSlots/CtaSlots';

const InfoDarkSection = ({ data: { primary }, styling }) => {
    const { heading, subheading, cta } = primary;
    return (
        <Box
            gridColumn={{ _: '1/-1', lg: '2/-2' }}
            display="flex"
            flexDirection="column"
            justifyItems="center"
            textAlign="center"
        >
            <Head2 bold color="neutral.white">
                {heading.text}
            </Head2>

            {subheading && (
                <Body1 mt="20px" color="neutral.white">
                    {subheading}
                </Body1>
            )}
            <Box width="100%">
                {cta?.document && (
                    <Box
                        display="flex"
                        justifyContent={{ xs: 'center' }}
                        flexDirection={{ _: 'column', xs: 'row' }}
                        mt="48px"
                        gap="16px"
                    >
                        <CtaSlots CTA={cta} bg={styling?.backgroundVariant} />
                    </Box>
                )}
            </Box>
        </Box>
    );
};

// TODO: convert to fragments
export const _ = graphql`
    fragment INFO_DARK_SECTION on PrismicSectionDataBodyInfoDarkSection {
        id
        primary {
            heading {
                text
            }
            subheading
            cta {
                document {
                    ... on PrismicCta {
                        id
                        data {
                            body {
                                ... on PrismicCtaDataBodyButtons {
                                    id
                                    items {
                                        __typename
                                        text
                                        variant
                                        tracking_event
                                        size
                                        link {
                                            ...PRISMIC_LINK_FRAGMENT
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }
`;

export default WithSection(InfoDarkSection);
